import './ExpiredPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import ModalConfirm from 'components/ModalConfirm';

import { updateTitle } from 'containers/App/store/actions';

class ExpiredPage extends React.Component {
    componentWillMount() {
        this.props.updateTitle('Expired Session');
        document.body.classList.add('auth-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
    }

    render() {
        return (
            <ModalConfirm show={true}
                          confirmAction={() => this.props.changeLocation('/logout')}
                          text="Your session has timed out. Please log back in."
                          title="We're sorry." />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        updateTitle: (string) => dispatch(updateTitle(string))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredPage);



// WEBPACK FOOTER //
// ./src/containers/AuthPages/ExpiredPage/index.js